import { createEntityAdapter } from '@reduxjs/toolkit';

const connectorsAdapter = createEntityAdapter();

export default connectorsAdapter;
